import React from "react";
import WorkspacesComponent from "../../components/workspaces/workspaces-component.component";

export default function WorkspacesPage() {
  return <WorkspacesComponent />;
}
